"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var utils_1 = require("../model/utils");
var constant_1 = require("../utils/constant");
var wrapper_1 = require("../utils/wrapper");
var fetchCompany = function () {
    return wrapper_1.getClients()
        .restClient.get(constant_1.FETCH_COMPANY_URL)
        .then(function (_a) {
        var data = _a.data;
        return ({ data: data });
    })
        .catch(utils_1.errorHandler);
};
var company = {
    fetchCompany: fetchCompany,
};
var init = function () { return company; };
exports.init = init;
